module.exports = __webpack_public_path__ + "img/PRCA1_CD8Tex.34762345.png";